import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import { getAccountShiftsAsync, resetSelectedRecordObjectInState, DeleteSelectedAccountShiftAsync, updatePagination } from "./ShiftSlice";
import ShiftItem from './ShiftItem';
import ShiftForm from './ShiftForm';
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import CustomPagination from "../../../common/Pagination";
import Select, { StylesConfig } from 'react-select';
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import OffCanvas from '../../../common/OffCanvas';
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList, sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import PageSizeSelect from '../../../common/PageSizeSelect';

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}

export const Shift = () => {

    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const { shiftList, isReload, selectedRecord, isLoading, sortOrder, sortColumn, search, pageNo, pageSize } = useAppSelector((state) => state.shift);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const [tab, setTab] = useState('Shift');

    const setActiveTab = (tab: string) => {
        setTab(tab);
    }

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    // const filteredData = getFilteredList(shiftList,searchTerm);
    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = shiftList.length;
    // const recordsFiltered = filteredData.length;

    const filteredData: any = getFilteredList(shiftList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = shiftList.length;
    const recordsFiltered = filteredData.length;


    useEffect(() => {
        if (isReload) {
            dispatch(getAccountShiftsAsync());
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getAccountShiftsAsync());
    }, [dispatch])

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        setActiveTab('Shift');
    }


    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    const selectedShiftList = shiftList
                        .filter(item => item.isSelected === 1)
                        .map(item => ({
                            AccountShiftId: item.AccountShiftId
                            // isSelected: item.isSelected
                        }));    
                    dispatch(DeleteSelectedAccountShiftAsync(selectedShiftList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            if (originalPromiseResult.StatusCode === "200") {
                                // setCurrentPage(1);
                                ShowToast("Shift Deleted Successfully", 'Success', "success", "toast-top-right")
                            }
                            else {
                                ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            }
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {

            });
    }

    const generalObject = {
        "name": (Object.keys(selectedRecord).length > 0 ? getValueFromResource('Update Shift', dispatch, t) : getValueFromResource('Add Shift', dispatch, t)),
        "width": "700px",
        "componentName": <ShiftForm t={t} tab={tab} onSetActiveTab={setActiveTab} />
    }

    return (
        <>
            {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle"  >
                        {/* {t('Shifts')} */}
                        {getValueFromResource('Shifts', dispatch, t)}
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search', dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"

                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}  >
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                            <PageSizeSelect onChange={handlePageSizeChange} />

                        </div>


                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                    recordsFiltered={recordsFiltered}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {(IsAdd || (IsDelete && shiftList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ):null
                        } */}

                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                        recordsFiltered={recordsFiltered}
                                    />
                                </div>
                            </>
                        )}

                        {(IsAdd || (IsDelete && shiftList.some((item: any) => item.isSelected === 1))) && (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        )}

                        {IsAdd &&
                            <button id="kt_OffCanvas" type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: shiftList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Shift')} */}
                                {getValueFromResource('Add Shift', dispatch, t)}

                            </button>

                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: shiftList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{shiftList.filter((item: any) => item.isSelected === 1).length}</span>
                                    {/* {t('Selected')} */}
                                    {getValueFromResource('Selected', dispatch, t)}

                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: shiftList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete', dispatch, t)}

                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <ShiftItem shiftList={currentItems} t={t} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
                }
            </div>
            <OffCanvas obj={generalObject} />
        </>
    )
}


